require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ./~/@xlts.dev/angular-resource/index.js
// module id = 444
// module chunks = 0